import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Home from "@/pages/Home";
import JoinRoom from "@/pages/JoinRoom";
import GameRoom from "@/pages/GameRoom";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import UpgradePage from "@/pages/UpgradePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminDashboard from "@/pages/AdminDashboard";
import StageView from "@/pages/StageView";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Feedback from "@/pages/Feedback";
import "@/App.css";

function AppRouter() {
  // Google sign-in now redirects server-side (backend sets the cookie and sends the
  // browser straight to "/"), so there's no client-side auth-callback route anymore.
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/upgrade" element={<UpgradePage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/join" element={<JoinRoom />} />
      <Route path="/room/:roomCode" element={<GameRoom />} />
      <Route path="/room/:roomCode/stage" element={<StageView />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/feedback" element={<Feedback />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
